export function Assertive() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4706 3.52939C13.4198 3.52939 15 5.10955 15 7.05882C15 8.89515 13.5976 10.4039 11.8054 10.5726C11.2499 12.8491 8.61258 14.7794 5.95588 14.7794C5.9376 14.7794 5.91932 14.7783 5.90115 14.776C3.88084 14.5235 0 7.50097 0 4.41176C0 1.75702 0.993106 0 2.20588 0C2.66271 0 3.40389 0.228076 4.48421 0.68294C4.97499 0.8896 5.29412 1.37024 5.29412 1.90274V2.54291C5.29412 3.04424 5.01088 3.50253 4.56249 3.72671L4.52827 3.74203L2.67639 4.47879C2.86567 5.46088 3.96747 6.94228 5.87001 8.80213C6.17118 7.81772 6.95206 7.03421 7.95527 6.74136C8.11576 4.94086 9.62836 3.52939 11.4706 3.52939Z"
        fill="url(#paint0_linear_0_83)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_0_83"
          x1="7.5"
          y1="0"
          x2="7.5"
          y2="14.7794"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
